import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InteractionsService } from 'src/app/services/interactions.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-interaction-complete',
  templateUrl: './interaction-complete.component.html',
  styleUrls: ['./interaction-complete.component.scss']
})
export class InteractionCompleteComponent implements OnInit, OnDestroy {

  public id;
  public type;
  public content;
  public interaction;
  private interactionSubscriber;
  public language;

  constructor(
    private activatedRoute: ActivatedRoute,
    private interactionsService: InteractionsService,
    private router: Router,
    public deviceDetector: DeviceDetectorService
  ) {
    this.language = localStorage.getItem('l')
  }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.params.id;
    this.type = this.activatedRoute.snapshot.params.type;
    this.interactionSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      if (!interactions) { // the main page was not been initializated
        // init the interactions Subject
        this.interactionsService.getInteractions();
      } else {
        this.interaction = interactions.filter(int => int.id == this.id)[0];
        this.content = this.interaction.onComplete.content;
      }
    });
  }

  onReset(interaction) {
    interaction.completed = {
      onComplete: false,
      status: null
    };
    this.interactionsService.updateInteraction(interaction);
    this.interactionsService.resetInteraction(interaction);
    if (this.interaction.type !== 'custom') {
      this.router.navigate(['/interaction/', this.interaction.type, this.interaction.url]);
    } else {
      this.router.navigate(['/interaction-custom/', this.interaction.type, this.interaction.url]);
    }
  }

  ngOnDestroy() {
    this.interactionSubscriber.unsubscribe();
  }

}
